<div class="flex flex-col items-center">
	<ui-datepicker-navigation
		[currentlyDisplayMonth]="currentlyDisplayedMonthVal()"
		(dateChange)="navDateChange.emit($event)"
		(todayClick)="onTodayClick()"
		[minDate]="minDate()"
		[maxDate]="maxDate()"
		[disabled]="disabled()"
		class="mb-2 max-w-full"
	></ui-datepicker-navigation>
	<ui-datepicker-calendar
		[minDate]="minDate()"
		[maxDate]="maxDate()"
		[disabled]="disabled()"
		[currentSelection]="selectedDate()"
		[currentlyDisplayedMonth]="currentlyDisplayedMonth()"
		[syncedDate]="syncedDate()"
		[excludedDates]="excludedDates()"
		(dateSelectionChanged)="dateSelectionChange.emit($event)"
		(monthChange)="navDateChange.emit($event)"
		(calendarWeekClicked)="calendarWeekClicked.emit($event)"
		class="w-full"
	></ui-datepicker-calendar>
</div>
